import DOMPurify from 'dompurify';
export const initializeDOMPurify = () => DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    if ('target' in node) {
        node.setAttribute('target', '_blank');
    }
    if (!node.hasAttribute('target') &&
        (node.hasAttribute('xlink:href') || node.hasAttribute('href'))) {
        node.setAttribute('xlink:show', 'new');
    }
});
//# sourceMappingURL=dompurify.util.js.map